import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpVentures'

export const investmentList = (params = '') => Http.get(`/admin/investments${serialize(params)}`)
export const investmentCreate = (params = '') => Http.post('/admin/investments', params)
export const investmentByID = (params = '') => Http.get(`/admin/investments/${params}`)
export const investmentUpdate = (params = '') => Http.put(`/admin/investments/${params.id}`, params)
export const investmentDestroy = (params = '') => Http.delete(`/admin/investments/${params.id}`)
